import { motion } from "framer-motion";
import { fadeUp, stagger } from "./motion";
import { useLang } from "../i18n";

const NUMS = ["01", "02", "03", "04"];

const PROCESS_IMG =
  "https://images.pexels.com/photos/2929246/pexels-photo-2929246.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=800";

export const Manifesto = () => {
  const { t } = useLang();
  const chapters = t("manifesto.chapters");
  return (
    <section
      id="heritage"
      data-testid="manifesto-section"
      className="bg-secondary py-28 md:py-40"
    >
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-16 px-6 md:px-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-timber">
              {t("manifesto.kicker")}
            </span>
            <h2 className="mt-4 font-serif text-5xl font-medium leading-[0.95] tracking-tight text-brand-blue md:text-6xl">
              {t("manifesto.title")}
            </h2>
            <div className="mt-8 overflow-hidden rounded-sm">
              <img
                src={PROCESS_IMG}
                alt="Serene evergreen forest"
                className="h-72 w-full object-cover"
              />
            </div>
          </div>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="lg:col-span-8 lg:col-start-6"
        >
          {chapters.map((c, i) => (
            <motion.div
              key={NUMS[i]}
              variants={fadeUp}
              data-testid={`manifesto-chapter-${NUMS[i]}`}
              className="grid grid-cols-1 gap-6 border-t border-border py-12 md:grid-cols-12 md:gap-10"
            >
              <span className="font-serif text-6xl font-medium leading-none text-brand-timber md:col-span-3 md:text-7xl">
                {NUMS[i]}
              </span>
              <div className="md:col-span-9">
                <h3 className="font-serif text-3xl font-medium text-brand-blue md:text-4xl">
                  {c.title}
                </h3>
                <p className="mt-4 max-w-xl font-light text-base leading-relaxed text-brand-slate md:text-lg">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
